import * as React from 'react'
// libs
import { Virtuoso } from 'react-virtuoso'
import {
  DragDropContext,
  Draggable,
  DraggableProvided,
  DraggableRubric,
  DraggableStateSnapshot,
  Droppable,
  DropResult
} from 'react-beautiful-dnd'
// view components
import Option from '../Option'
// views
import { Item, Row } from './views'
// types
import { IFieldOption } from 'types/graphql'

const VIRTUOSO_COMPONENTS = { Item }

interface Props {
  isDisabled: boolean
  options: IFieldOption[]
  scrollParent: HTMLElement
  onDragEnd: (result: DropResult) => void
  removeOption: (id: string) => () => void
}

const OptionsList: React.FC<Props> = ({ isDisabled, options, scrollParent, onDragEnd, removeOption }) => {
  const renderRow = (provided: DraggableProvided, option: IFieldOption) => (
    <Row
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={provided.draggableProps.style as React.CSSProperties}>
      <Option option={option} removeOption={removeOption(option.id)} isDisabled={isDisabled} />
    </Row>
  )

  // in virtual mode the dragged row is rendered as a clone: its source can be unmounted while scrolling
  const renderClone = (provided: DraggableProvided, _: DraggableStateSnapshot, rubric: DraggableRubric) =>
    renderRow(provided, options[rubric.source.index])

  // the list has no scroller of its own: it is virtualized against the modal scroll container
  if (!scrollParent) {
    return null
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={'OPTIONS'} mode='virtual' renderClone={renderClone}>
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            <Virtuoso
              data={options}
              components={VIRTUOSO_COMPONENTS}
              customScrollParent={scrollParent}
              computeItemKey={(_, option) => option.id}
              itemContent={(index, option) => (
                <Draggable draggableId={option.id} index={index} isDragDisabled={isDisabled}>
                  {(provided) => renderRow(provided, option)}
                </Draggable>
              )}
            />
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default OptionsList
